<app-documents-multiselect-toolbar
  [visible]="isMultiSelectMode"
  (downloadSelected)="downloadSelected()"
  (deleteSelected)="deleteSelected()"
  (cancelSelection)="multiSelectMode()"
/>

<app-documents-header
  [animal]="animal"
  [filter]="filter"
  [categoryOptions]="categoryOptions"
  [documents]="documents"
  [isMultiSelectMode]="isMultiSelectMode"
  (multiSelectToggle)="multiSelectMode()"
  (filterChange)="onFilterChange()"
/>

<app-documents-grid
  [animal]="animal"
  [documents]="filteredDocuments"
  [flippedItems]="flippedItems"
  [isMultiSelectMode]="isMultiSelectMode"
  [selectedIds]="selectedIds"
  [categoryOptions]="categoryOptions"
  (toggleSelect)="toggleSelect($event)"
  (toggleFlip)="toggleFlip($event.id, $event.event)"
  (categoryChange)="onCategoryChange($event)"
  (dateChange)="onDateChange($event)"
  (deleteDocument)="deleteDocument($event)"
  (downloadDocument)="downloadSingle($event)"
  (replaceFile)="onReplaceFile($event)"
/>
